import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Button } from 'react-bootstrap';
import './styles/action-intro.css';
import instructionsImage from '../assets/images/instructions-1.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { pageNames } from 'config/pageNames';

const ActionInstructions: React.FC = () => {
  return (
    <Container className="how-to-use-container">
      {/* Top right skip */}
      <Row className="justify-content-end mb-2">
        <Col xs="auto">
          <Link to={pageNames.HOME}>
            <Button variant="outline-secondary" className="howto-button howto-button--secondary">
              Skip instructions
            </Button>
          </Link>
        </Col>
      </Row>

      <section className="how-to-use-card">
        <Row className="align-items-center how-to-use-main">
          <Col xs={12} md={6}>
            <header className="how-to-use-header">
              <p className="how-to-use-kicker">Getting started</p>
              <h1 className="how-to-use-title">How to use this platform</h1>
              <p className="how-to-use-subtitle">
                You’re part of a community co-creating this tool. Things might not
                look perfect yet – and that’s the opportunity for you to help shape it.
              </p>
            </header>

            <ul className="how-to-use-list">
              <li>
                <strong>Generate more actions:</strong> Press this button to get a
                choice of credible and creative actions that you could take so your
                event advances sustainability commitments.
              </li>
              <li>
                <strong>Add:</strong> Press this button if the action sounds relevant
                to <strong>your</strong> specific event to add it to your list.
              </li>
              <li>
                <strong>Customise:</strong> Press this button to tailor the action to
                your event. A key benefit is that you can download the list and share
                it with suppliers, clients, or other stakeholders so the action
                reflects their reality.
              </li>
              <li>
                <strong>Remove:</strong> Press this button if you don’t want this
                action on your list.
              </li>
              <li>
                <strong>Special actions:</strong>{' '}
                If you see an action marked with this icon{' '}
                <FontAwesomeIcon icon={faFileCircleQuestion} className="how-to-use-icon-special" />,
                it has support material attached. Click <strong>Customise</strong> to
                view links to these resources.
              </li>
            </ul>
          </Col>

          <Col xs={12} md={6} className="how-to-use-image-col">
            <div className="how-to-use-image-wrapper">
              <img
                src={instructionsImage}
                alt="Instructions"
                className="img-fluid how-to-use-image"
              />
            </div>
          </Col>
        </Row>

        {/* Words of advice */}
        <Row className="mt-3">
          <Col>
            <section className="how-to-use-advice">
              <p className="how-to-use-advice-label d-none">
                A few words of advice from initial co-creators Fiona Pelham and Eddie
                Dikgale:
              </p>
              <blockquote className="how-to-use-quote">
                “This platform has been created so that events are recognized as an
                engagement tool that can advance progress towards The Paris Agreement,
                Race to Zero commitments, and The United Nations Sustainable
                Development Goals. We understand the creativity of the global event
                supply chain, and we hope this platform will be a resource to inspire
                and enable creativity that aligns with regulation, addresses
                greenwash, and advances sustainability.”
              </blockquote>

              <p className="smaller-text d-none">
                Here is the advice to our first 1,000 curious users who will help
                shape the future of this platform:
              </p>
              <ul className="how-to-use-list smaller-text">
                <li>Press all the buttons — it's ok if you break something.</li>
                <li>
                  Focus on a future event; share your action list with your client or
                  supply chain and ask if it helps them.
                </li>
                <li>
                  <strong>Customise</strong> and <strong>Add your own actions</strong>{' '}
                  should be your favourite sections — over 50% of your list should be
                  your own actions, because your event is unique.
                </li>
                <li>
                  Remove anything that isn’t useful — use the remove button without
                  second-guessing yourself.
                </li>
              </ul>

              <p className="smaller-text mt-2">
                Finally, thank you for participating with a global community of
                curious and collaborative event professionals keen to demonstrate how
                events can advance progress and address the challenges of our time.
              </p>
            </section>
          </Col>
        </Row>

        {/* Bottom right: return CTA */}
        <Row className="justify-content-end mt-3">
          <Col xs="auto">
            <Link to={pageNames.HOME}>
              <Button variant="outline-primary" className="howto-button howto-button--primary">
                Return to welcome page…
              </Button>
            </Link>
          </Col>
        </Row>
      </section>
    </Container>
  );
};

export default ActionInstructions;
